import AbstractVertical from './AbstractVertical'

type VerticalMap = {[key: string]: string}

class VerticalRegistry {

  #verticals: {[key: string]: AbstractVertical} = {}
  map: VerticalMap = {}

  /**
   * Add a vertical to the registry.
   */
  register(vertical: AbstractVertical) {
    this.#verticals[vertical.name] = vertical
  }

  /**
   * Retrieve a registered vertical by name.
   */
  get(name: string): AbstractVertical | undefined {
    return this.#verticals[name] ?? null
  }

  getTitle(name: string): string {
    return this.#verticals[name]?.title ?? name
  }

  /**
   * Retrieve an array of all registered verticals, optionally limited to those
   * which support the specified feature(s).
   */
  getMany(features: string[] = []): AbstractVertical[] {
    return Object.values(this.#verticals).filter((vertical) => {
      return vertical.supports(features)
    })
  }

  /**
   * Returns an array suitable for passing to the items prop of a Vuetify form
   * component.
   */
  getOptions(features: string[] = []): {value: string, title: string}[] {
    return this.getMany(features).map((vertical) => {
      return {value: vertical.name, title: vertical.title}
    })
  }

  getOptionsMap(): {[key: string]: string} {
    const map: {[key: string]: string} = {}
    Object.values(this.#verticals).forEach(vertical => {
      map[vertical.name] = vertical.title
    })
    return map
  }

  getColorMap(): {[key: string]: string} {
    const map: {[key: string]: string} = {}
    Object.values(this.#verticals).forEach(vertical => {
      map[vertical.name] = vertical.color
    })
    return map
  }

}

export default new VerticalRegistry()
